import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import whiteBackground from '../wrapper-components/white-background';
import { fetchAttendees } from '../app-main/actions/attendees';
import { fetchBooking } from '../app-main/actions/booking';
import { Spinner } from 'shared-components/decorators/spinner';
import AttendeePublic from './attendee-public';
import { FormattedMessage } from 'react-intl';

/* global: PSSessions */
class AttendeePageMain extends Component {
  constructor (props) {
    super(props);

    this.attendeeListRef = null;

    this.redirectUserToHomepage = this.redirectUserToHomepage.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.buildAnalyticProps = this.buildAnalyticProps.bind(this);
    this.setMetroAndActivityCookies = this.setMetroAndActivityCookies.bind(this);
  }

  componentWillMount () {
    // addLocaleData([...en, ...fr, ...de]);
    const accessToken = this.getAccessToken();
    const publicBookingId = _.get(this.props, 'routeParams.publicBookingId');
    const { dispatch } = this.props;

    dispatch(fetchAttendees(publicBookingId));
    dispatch(fetchBooking(publicBookingId, accessToken));
  }

  componentDidUpdate (prevProps) {
    const booking = _.get(this.props, 'booking.booking');
    const prevBooking = _.get(prevProps, 'booking.booking');
    const error = _.get(this.props, 'booking.error');
    const prevError = _.get(prevProps, 'booking.error');

    if (_.isEmpty(prevBooking) && !_.isEmpty(booking)) { // Page load
      const userSsoId = _.get(this.props, 'profile.SSOid');
      const guestSsoId = _.get(this.props, 'booking.booking.guest.ssoid');
      const isUserGuest = userSsoId === guestSsoId;
      const shareState = _.get(booking, 'share_state');
      const visibility = ('public' === shareState) ? 'public' : 'private';

      const analyticsProp = this.buildAnalyticProps({
        visibility,
        guest: isUserGuest, // this is set to `true` if the logged in guest is viewing the page, otherwise it's set to `false`
        pid: _.get(booking, 'pid')
      });

      this.setMetroAndActivityCookies();
      analyticsIntegrations.publicAttendee('attendee details: page viewed', analyticsProp);
    } else if (!prevError && error) { // Page load error
      const analyticsProp = this.buildAnalyticProps({
        visibility: 'private',
        guest: false,
        pid: _.get(booking, 'pid')
      });

      this.setMetroAndActivityCookies();
      analyticsIntegrations.publicAttendee('attendee details: page viewed', analyticsProp);
    }
  }

  setMetroAndActivityCookies () {
    const listing = _.get(this.props, 'booking.booking.listing');

    if (listing) {
      const useType = _.get(listing, 'use_type', null);
      const metro = _.get(listing, 'metro', null);

      if (metro && PSSessions) {
        PSSessions.set.metro(metro);
      }

      if (useType && PSSessions) {
        PSSessions.set.thisCookie('PSUT', useType);
      }
    }
  }

  /* helpers */
  getAccessToken () {
    return _.get(this.props, 'auth.accessToken');
  }

  redirectUserToHomepage () {
    analyticsIntegrations.publicAttendee('attendee details: explore spaces', this.buildAnalyticProps());

    setTimeout(function makeLoginLinkRedirect () {
      const fullLink = location.origin;
      location.href = fullLink;
    }, 0);
  }


  buildAnalyticProps (extraAnalyticProps) {
    const booking = _.get(this.props, 'booking.booking');
    const bookingId = _.get(booking, '_id');
    const wifiInstructions = _.get(booking, 'space.wifi_instructions');
    const gettingThere = _.get(booking, 'space.getting_there');

    return {
      label: bookingId,
      wifi: !!wifiInstructions,
      getting_there: !!gettingThere,
      ...extraAnalyticProps
    };
  }

  render () {
    const isFetchingBooking = _.get(this.props, 'booking.isFetching');

    if (isFetchingBooking) {
      return (
        <div className="AttendeePageMain container-fluid">
          <div className="content-container flex center">
            <Spinner additionalStyle="gray large" />
          </div>
        </div>
      );
    }

    const booking = _.get(this.props, 'booking.booking');
    const shareState = _.get(booking, 'share_state');
    const userSsoId = _.get(this.props, 'profile.SSOid');
    const guestSsoId = _.get(this.props, 'booking.booking.guest.ssoid');
    const isUserGuest = userSsoId === guestSsoId;

    if ('public' !== shareState && !isUserGuest) {
      return (
        <div className="AttendeePageMain container-fluid">
          <div className="text-center error-attendee-page">
            <h3>
              <FormattedMessage id='invite.attendee_page_main.not_available' defaultMessage='This page is no longer available' />
            </h3>

            <p>
              <FormattedMessage id='invite.attendee_page_main.contact_organizer' defaultMessage='Please contact your event organizer.' />
              <br />
              <FormattedMessage id='invite.attendee_page_main.you_organizer' defaultMessage="If you're the event organizer, please login to see the page." />
            </p>

            <div onClick={this.redirectUserToHomepage}>
              <a className="btn btn-primary">
                <FormattedMessage id='invite.attendee_page_main.explore_spaces' defaultMessage='Explore Spaces' />
              </a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="AttendeePageMain container-fluid">
        <AttendeePublic
          whichModal={this.props.whichModal}
          whichModalCb={this.props.whichModalCb}
          toggleModal={this.props.toggleModal}
          location={this.props.location}
        />
      </div>
    );
  }
}

AttendeePageMain.propTypes = {
  dispatch: PropTypes.func
};

function mapStateToProps (state) {
  const { attendees, booking, auth, profile } = state;

  return {
    attendees,
    booking,
    auth,
    profile
  };
}

export default connect(mapStateToProps)(whiteBackground(AttendeePageMain));
